function getQuarterMonth(quarter) {
  var month = quarter * 3 - 2;
  return month === 10 ? month : "0".concat(month);
}

function getPrevousVersion(year, quarter, nQuarter) {
  var versionQuarter = quarter - nQuarter;

  if (versionQuarter <= 0) {
    return "".concat(year - 1, "-").concat(getQuarterMonth(versionQuarter + 4));
  }

  return "".concat(year, "-").concat(getQuarterMonth(versionQuarter));
}

function getCurrentApiVersion() {
  var date = new Date();
  var month = date.getUTCMonth();
  var year = date.getUTCFullYear();
  var quarter = Math.floor(month / 3 + 1);
  return {
    year: year,
    quarter: quarter,
    version: "".concat(year, "-").concat(getQuarterMonth(quarter))
  };
}

function getCurrentSupportedApiVersions() {
  var _getCurrentApiVersion = getCurrentApiVersion(),
      year = _getCurrentApiVersion.year,
      quarter = _getCurrentApiVersion.quarter,
      currentVersion = _getCurrentApiVersion.version;

  var nextVersion = quarter === 4 ? "".concat(year + 1, "-01") : "".concat(year, "-").concat(getQuarterMonth(quarter + 1));
  return [getPrevousVersion(year, quarter, 3), getPrevousVersion(year, quarter, 2), getPrevousVersion(year, quarter, 1), currentVersion, nextVersion, 'unstable'];
}

export { getCurrentApiVersion, getCurrentSupportedApiVersions };